import { Icon } from '@chakra-ui/react';

export default function SFSparkleStarIcon(props) {
  return (
    <Icon
      xmlns='http://www.w3.org/2000/svg'
      w={3}
      h={3}
      viewBox='0 0 12 12'
      fill='currentColor'
      {...props}
    >
      <path d='m9.262 6.05-2.418-.894-.89-2.42a.746.746 0 0 0-1.402 0l-.896 2.42-2.42.89a.746.746 0 0 0 0 1.401l2.42.897.89 2.42a.746.746 0 0 0 1.401 0l.897-2.42 2.42-.89a.746.746 0 0 0 0-1.401zm-2.84 1.648a.38.38 0 0 0-.222.222l-.95 2.573-.948-2.571a.38.38 0 0 0-.224-.224L1.507 6.75l2.571-.948a.38.38 0 0 0 .224-.224l.948-2.571.948 2.571a.38.38 0 0 0 .222.222l2.573.95zm.328-5.823a.375.375 0 0 1 .375-.375h.75V.75a.375.375 0 0 1 .75 0v.75h.75a.375.375 0 0 1 0 .75h-.75V3a.375.375 0 1 1-.75 0v-.75h-.75a.375.375 0 0 1-.375-.375m4.875 2.25a.375.375 0 0 1-.375.375h-.375v.375a.375.375 0 0 1-.75 0V4.5H9.75a.375.375 0 0 1 0-.75h.375v-.375a.375.375 0 1 1 .75 0v.375h.375a.375.375 0 0 1 .375.375' />
    </Icon>
  );
}
